// extracted by mini-css-extract-plugin
export default {"container":"Vdjm1taECspL9NfU8Kx_","content":"vvmm5MsHL1zLCWx2DH9K","icon":"XXmNHZd_mAnqKjqNkA2r","title":"CBDk2YM1I8XueDDtIHnE"};